/*
* 2016 Studio Aquion
*
*  @author    Studio Aquilon
*  @copyright 2016 Studio Aquilon
*  @license   not for sale excepted on Prestashop Addons with Szczepaniak Xavier's permission
*/

import $ from 'jquery';

export default class InitPhotoswipe {

  constructor(index,slick){

    var items = [];
    var image = [];

    $('.pic').each( function() {
        var $pic     = $(this),
            getItems = function() {
                $pic.find('a').each(function() {
                    var $href   = $(this).attr('href'),
                        $size   = $(this).data('size').split('x'),
                        $width  = $size[0],
                        $height = $size[1],
                        $description = $(this).data('legend');

                    var item = {
                        src : $href,
                        msrc: $href,
                        w   : $width,
                        h   : $height,
                        title: $description
                    }

                    items.push(item);
                });
                return items;
            }

        items = getItems();

        $.each(items, function(index, value) {
            image[index]     = new Image();
            image[index].src = value['src'];

        });


    });

    var $index = index;
    var options = {
        index: $index,
        bgOpacity: 0.7,
        tapToToggleControls: false,
        tapToClose: true,
        showHideOpacity:true,

        getThumbBoundsFn: function(index) {
          // find thumbnail element
          var thumbnail = document.querySelector('.product-slider');
          // get window scroll Y
          var pageYScroll = window.pageYOffset || document.documentElement.scrollTop; 
          // optionally get horizontal scroll
          // get position of element relative to viewport
          var rect = thumbnail.getBoundingClientRect(); 
          // w = width
          return {x:rect.left, y:rect.top + pageYScroll, w:rect.width};
        }
    }
    var lightBox = new PhotoSwipe($('.pswp')[0], PhotoSwipeUI_Default, items, options);
    lightBox.init();

    return lightBox;

  }

}







// WEBPACK FOOTER //
// ./js/lib/photoswipe-init.js